// extracted by mini-css-extract-plugin
export default {"form_control":"AuthSignIn_form_control__j26Ah","form_control__login":"AuthSignIn_form_control__login__wwXjY","signUp_link":"AuthSignIn_signUp_link__t6uL5"};